import { RouteHttpVerb } from "@devowl-wp/utils";
const locationRestImportPost = {
    path: "/import",
    method: RouteHttpVerb.POST
};
export { locationRestImportPost };
